import React from 'react';

import Box from '@material-ui/core/Box';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import {
  closeCommunicationPanel,
  useIsCommunicationPanelExpanded,
  useIsCommunicationPanelOpen
} from '../../../lib/stores/communication.store';
import { CommunicationPanelProvider } from './communication-panel-context';
import { CommunicationPanelBody } from './communication-panel-body.component';
import { CommunicationPanelHeader } from './communication-panel-header.component';
import { EXPANDED_PANEL_WIDTH, PANEL_WIDTH, StyledDrawer } from './communication-panel.styles';

export const CommunicationPanel: React.FC = () => {
  const isOpen = useIsCommunicationPanelOpen();
  const isExpanded = useIsCommunicationPanelExpanded();
  // Tablet and below always render full-screen — a 560px side drawer leaves an
  // unusable sliver of app beside it. On wider screens the stored preference wins.
  const theme = useTheme();
  const isTabletOrSmaller = useMediaQuery(theme.breakpoints.down('md'));
  const fullScreen = isTabletOrSmaller || isExpanded;

  return (
    <StyledDrawer
      anchor="right"
      open={isOpen}
      onClose={closeCommunicationPanel}
      ModalProps={{ keepMounted: true }}
      PaperProps={{ style: { width: fullScreen ? EXPANDED_PANEL_WIDTH : PANEL_WIDTH, maxWidth: '100vw' } }}
    >
      <CommunicationPanelProvider>
        <Box display="flex" flexDirection="column" height="100%">
          <CommunicationPanelHeader />
          <CommunicationPanelBody />
        </Box>
      </CommunicationPanelProvider>
    </StyledDrawer>
  );
};
